export var textFieldPropSize = ['m', 'xs', 's', 'l'];
export var textFieldPropSizeDefault = textFieldPropSize[0];
export var textFieldPropView = ['default', 'clear', 'outline'];
export var textFieldPropViewDefault = textFieldPropView[0];
export var textFieldPropForm = [
    'default',
    'defaultClear',
    'defaultBrick',
    'brick',
    'brickDefault',
    'brickClear',
    'brickRound',
    'round',
    'roundClear',
    'roundBrick',
    'clearRound',
    'clearDefault',
    'clearBrick',
    'clearClear',
];
export var textFieldPropFormDefault = textFieldPropForm[0];
export var textFieldPropStatus = ['alert', 'success', 'warning'];
export var textFieldPropWidth = ['default', 'full'];
export var textFieldPropWidthDefault = textFieldPropWidth[0];
export var sizeMap = {
    xs: 'xs',
    s: 's',
    m: 's',
    l: 'm'
};
